import React from 'react';
import { motion } from 'framer-motion';

type QuickActionCardProps = {
  icon: React.ComponentType<any>;
  title: string;
  subtitle: string;
  ctaLabel: string;
  onClick: () => void;
  tone?: 'primary' | 'success' | 'purple';
};

const QuickActionCard: React.FC<QuickActionCardProps> = ({
  icon: Icon,
  title,
  subtitle,
  ctaLabel,
  onClick,
  tone = 'primary',
}) => {
  const iconColorClass = {
    primary: 'text-primary-600',
    success: 'text-success-600',
    purple: 'text-purple-600',
  }[tone];

  const buttonClass = {
    primary: 'btn-primary',
    success: 'btn-success',
    purple: 'btn-primary bg-purple-600 hover:bg-purple-700 focus:ring-purple-500',
  }[tone];

  return (
    <motion.div
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.98 }}
      className="card text-center min-h-[220px] flex flex-col justify-between p-6"
    >
      <div className="flex-1 flex flex-col items-center justify-center">
        <Icon className={`mx-auto h-12 w-12 ${iconColorClass}`} />
        <h3 className="mt-2 text-sm font-medium text-gray-900">{title}</h3>
        <p className="mt-1 text-sm text-gray-500 line-clamp-2">{subtitle}</p>
      </div>
      <button onClick={onClick} className={`mt-4 ${buttonClass} btn-sm w-full`}>
        {ctaLabel}
      </button>
    </motion.div>
  );
};

export default QuickActionCard;
